import React, { useState, memo } from 'react';
// PropType
import PropTypes from 'prop-types';
import { ADGMPanel } from 'aurora-components';
import withStyles from '@material-ui/core/styles/withStyles';
import { RadioGroup, Radio, FormControl, FormControlLabel } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import moment from 'moment';
import { keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';
const ADGMRadioList = ({ classes, title, optionList, selectedOption, isEditable = false }) => {
  if (isEmpty(optionList)) return true;
  const [selectedValue, setSelectedValue] = useState('');

  const handleRadioChange = event => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    selectedOption(newValue);
  };

  return (
    <ADGMPanel title={title}>
      <div className={classes.container}>
        <FormControl component='fieldset'>
          <RadioGroup value={selectedValue}>
            {!isEmpty(optionList) &&
              isObject(optionList) &&
              optionList.map((option, index) => (
                <FormControlLabel
                  key={option.id}
                  value={option.id}
                  control={isEditable ? <Radio /> : <div className={classes.container} />}
                  onChange={handleRadioChange}
                  checked={String(selectedValue) === String(option.id)}
                  label={
                    <>
                      {isEditable ? (
                        <>
                          {option.visitDate && moment(option.visitDate).format('DD/MM/YYYY')} {option.startTime} -
                          {option.endTime}
                        </>
                      ) : (
                        <div className={classes.slotsTitle}>
                          {keyEmptyCheck('slot')} {index + 1}
                          <div className={classes.slotsValue}>
                            {option.visitDate && moment(option.visitDate).format('DD/MM/YYYY')} {option.startTime} -
                            {option.endTime}
                          </div>
                        </div>
                      )}
                    </>
                  }
                />
              ))}
          </RadioGroup>
        </FormControl>
      </div>
    </ADGMPanel>
  );
};
ADGMRadioList.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  optionList: PropTypes.object.isRequired,
  selectedOption: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
};

export default withStyles(styles)(memo(ADGMRadioList));
